
import { useState } from "react"
import { Container, Row, Col, Form, FormGroup, Label, Input, Button } from "reactstrap"
import { Briefcase } from "lucide-react"

export default function AddDepartment({update}) {
  const [formData, setFormData] = useState({
    departmentName: "",
    headOfDepartment: "",
    contactNumber: "",
    email: "",
    branchAssigned: "",
  })

  const [loading, setLoading] = useState(false)

  const handleInputChange = (e) => {
    const { name, value } = e.target
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }))
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    setLoading(true)

    setTimeout(() => {
      console.log("Department Data:", formData)
      alert("Department added successfully!")
      // Reset form
      setFormData({
        departmentName: "",
        headOfDepartment: "",
        contactNumber: "",
        email: "",
        branchAssigned: "",
      })
      setLoading(false)
    }, 1500)
  }

  const handleCancel = () => {
    setFormData({
      departmentName: "",
      headOfDepartment: "",
      contactNumber: "",
      email: "",
      branchAssigned: "",
    })
  }

  return (

      <Container>
        <Row className="justify-content-center">
          <Col lg="8" md="10" xs="12">
            {/* Header Section */}
            <div className="mb-8">
              {update?(<h1 className="text-4xl font-bold text-black mb-2">Update Department</h1>):<h1 className="text-4xl font-bold text-black mb-2">Add Department</h1>}
              <p className="text-black text-lg">
                Fill in the details below to add a new department to your organization
              </p>
            </div>

            {/* Main Form Card */}
            <div className="bg-white border border-gray-200 rounded-lg p-4 shadow-sm">
              <Form onSubmit={handleSubmit}>
                {/* Department Info Icon Section */}
                <div className="mb-4 pb-4 border-b border-gray-200">
                  <div className="d-flex gap-3 align-items-center">
                    <div
                      className="bg-gray-100 rounded-lg p-3 d-flex align-items-center justify-content-center"
                      style={{ width: "50px", height: "50px" }}
                    >
                      <Briefcase size={24} className="text-black" />
                    </div>
                    <div>
                      <p className="text-black font-semibold mb-0">Department Details</p>
                      <p className="text-black text-sm mb-0">Manage your department information</p>
                    </div>
                  </div>
                </div>

                {/* Department Name Row */}
                <Row className="mb-5">
                  <Col md="12">
                    <FormGroup>
                      <Label for="departmentName" className="text-black font-semibold mb-2">
                        Department Name <span className="text-red-500">*</span>
                      </Label>
                      <Input
                        type="text"
                        name="departmentName"
                        id="departmentName"
                        placeholder="Enter department name "
                        value={formData.departmentName}
                        onChange={handleInputChange}
                        required
                        className="border-gray-300 py-2 px-3"
                        style={{ borderColor: "#e5e7eb" }}
                      />
                    </FormGroup>
                  </Col>
                </Row>

                {/* Head of Department and Email Row */}
                <Row className="mb-5">
                  <Col md="6" className="mb-4 mb-md-0">
                    <FormGroup>
                      <Label for="headOfDepartment" className="text-black font-semibold mb-2">
                        Head of Department <span className="text-red-500">*</span>
                      </Label>
                      <Input
                        type="text"
                        name="headOfDepartment"
                        id="headOfDepartment"
                        placeholder="Enter head's full name"
                        value={formData.headOfDepartment}
                        onChange={handleInputChange}
                        required
                        className="border-gray-300 py-2 px-3"
                        style={{ borderColor: "#e5e7eb" }}
                      />
                    </FormGroup>
                  </Col>
                  <Col md="6">
                    <FormGroup>
                      <Label for="email" className="text-black font-semibold mb-2">
                        Email <span className="text-red-500">*</span>
                      </Label>
                      <Input
                        type="email"
                        name="email"
                        id="email"
                        placeholder="Enter department email"
                        value={formData.email}
                        onChange={handleInputChange}
                        required
                        className="border-gray-300 py-2 px-3"
                        style={{ borderColor: "#e5e7eb" }}
                      />
                    </FormGroup>
                  </Col>
                </Row>

                {/* Contact Number and Branch Assigned Row */}
                <Row className="mb-5">
                  <Col md="6" className="mb-4 mb-md-0">
                    <FormGroup>
                      <Label for="contactNumber" className="text-black font-semibold mb-2">
                        Contact Number <span className="text-red-500">*</span>
                      </Label>
                      <Input
                        type="tel"
                        name="contactNumber"
                        id="contactNumber"
                        placeholder="+977"
                        value={formData.contactNumber}
                        onChange={handleInputChange}
                        required
                        className="border-gray-300 py-2 px-3"
                        style={{ borderColor: "#e5e7eb" }}
                      />
                    </FormGroup>
                  </Col>
                  <Col md="6">
                    <FormGroup>
                      <Label for="branchAssigned" className="text-black font-semibold mb-2">
                        Branch Assigned <span className="text-red-500">*</span>
                      </Label>
                      <Input
                        type="select"
                        name="branchAssigned"
                        id="branchAssigned"
                        value={formData.branchAssigned}
                        onChange={handleInputChange}
                        required
                        className="border-gray-300 py-2 px-3"
                        style={{ borderColor: "#e5e7eb" }}
                      >
                        <option value="">Select branch</option>
                        <option value="headquarters">Kathmandu Central</option>
                        <option value="branch-a">Lalitpur Office</option>
                        <option value="branch-b">Pokhara Lakeside</option>
                        <option value="branch-c">Biratnagar East</option>
                        <option value="branch-d">Chitwan Bharatpur</option>
                      </Input>
                    </FormGroup>
                  </Col>
                </Row>

                {/* Action Buttons */}
                <div className="d-flex gap-3 justify-content-end pt-6 border-t border-gray-200">
                  <Button
                    type="button"
                    color="light"
                    className="px-6 py-2 font-semibold text-black border border-gray-300"
                    onClick={handleCancel}
                    disabled={loading}
                  >
                    Cancel
                  </Button>
                  <Button
                    type="submit"
                    color="dark"
                    className="px-6 py-2 font-semibold bg-black text-white"
                    disabled={loading}
                  >
                    {loading ? "Submitting..." : "Submit"}
                  </Button>
                </div>
              </Form>
            </div>

            {/* Footer Info */}
            <div className="mt-6 text-center text-gray-500 text-sm">
              <p>
                All fields marked with <span className="text-red-500">*</span> are required
              </p>
            </div>
          </Col>
        </Row>
      </Container>

  )
}
